<ng-template #template let-anchor>
            <pop-product-compositions 
                [HiddenProductTooltip]= "true"
                [ProductName]="ProductName" 
                [ProductUnit]="ProductUnit" 
                [ProductCompositions]="ProductCompositions"
                [Deployed]="true"                                          
                class='pop-product-compositions-css'>
            </pop-product-compositions>
</ng-template>

<div kendoTooltip [tooltipTemplate]="template" filter="span" tooltipClass="compoTooltipClass" class="dv-product_compositions_button" title="{{PopinTooltip}}" >
        <span class="k-icon k-font-icon icon-chemistry" >       </span>             
</div>